import React from "react";
import Heading from "../ui/Heading";
import { Container } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

const Insta = () => {
  return (
    <section className="insta-section pb-0">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Get a Tour of our Social Media</h2>
          <p>
            Follow 
            <a
              href="https://www.instagram.com/adorebijoux/"
              className="text-dark"
              target="_blank"
              rel="noreferrer"
            >
              <strong style={{fontWeight:"600"}}> 
               &nbsp;  @Adore Bijoux Jewelers</strong>     &nbsp; 
            </a>
            on Instagram to get inspired
          </p>
        </Heading>
      </Container>
      <InstaIframe />
    </section>
  );
};

export default Insta;
